import { MixboardAPI } from "@/lib/mixboard/api";
import { useMixboard } from "@/state/useMixboard";
import { ChangeEvent } from "react";

export function ReferencePanel() {
  const refs = useMixboard((s) => s.references);
  const session = useMixboard((s) => s.session);
  const setReferences = useMixboard((s) => s.setReferences);

  const handleUpload = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file || !session) return;
    await MixboardAPI.uploadReference(session.id, file);
    const updated = await MixboardAPI.listReferences(session.id);
    setReferences(updated);
    event.target.value = "";
  };

  return (
    <div className="p-4 space-y-2 bg-muted rounded">
      <div className="grid grid-cols-3 gap-2">
        {refs.map((r) => (
          <img src={r.url} key={r.id} className="h-20 w-20 object-cover rounded" />
        ))}
      </div>
      <input type="file" onChange={handleUpload} className="text-sm" />
    </div>
  );
}
